import Button from '../../../../components/Assets/Button';
import Badge from '../../../../components/badge';
import {
  BadgeBackgroundColorEnum,
  BadgeContentEnum,
  BadgeTextColorEnum,
} from '../../../../components/badge/enums';
import styles from './foldersFooterContent.module.scss';
interface IFolderFooterContentProps {
  activeFolder: IFolder | null;
  onFolderUpdate: (folder: IFolder | null) => void;
  onFolderDelete: (folder: IFolder | null) => void;
}

function FolderFooterContent({
  activeFolder,
  onFolderUpdate,
  onFolderDelete,
}: IFolderFooterContentProps) {
  return (
    <div className={styles.foldersFooterContent}>
      <div className={styles.footerFoldersBtn}>
        <Button
          btnType="button"
          bgColor="violet"
          textColor="white"
          borderColor="white"
          btnImg="edit-white"
          handleClick={() => onFolderUpdate(activeFolder)}
        />
        <Button
          btnType="button"
          bgColor="red"
          textColor="white"
          btnImg="delete-white"
          handleClick={() => onFolderDelete(activeFolder)}
        />
      </div>
      <div className={styles.footerFolderName}>
        <p>{activeFolder?.name ?? ''}</p>
      </div>
      <div className={styles.footerFolderBadges}>
        <Badge
          badgeDynamicContent={`${activeFolder?.totalAdStudies ?? 0} annonces`}
          bgColor={BadgeBackgroundColorEnum.GREY}
          textColor={BadgeTextColorEnum.DARKER_GREY}
          isMini
        />
        <Badge
          badgeContent={BadgeContentEnum.MISE_A_JOUR}
          bgColor={BadgeBackgroundColorEnum.GREEN}
          textColor={BadgeTextColorEnum.WHITE}
          isMini
        />
      </div>
    </div>
  );
}

export default FolderFooterContent;
